<script>
  import { DropdownMenu } from 'element-ui'
  export default {
    name:'ElDropdownMenu',
    extends:DropdownMenu
  }
</script>
